import { useEffect, useRef, useState, type ReactNode } from 'react'

type Props = {
  children: ReactNode
  fallback: ReactNode
  rootMargin?: string
  minHeight?: number
}

export function LazyOnVisible({
  children,
  fallback,
  rootMargin = '200px',
  minHeight = 320,
}: Props) {
  const [visible, setVisible] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      setVisible(true)
      return
    }
    const obs = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]
        if (entry?.isIntersecting) {
          setVisible(true)
          obs.disconnect()
        }
      },
      { rootMargin },
    )
    obs.observe(ref.current)
    return () => obs.disconnect()
  }, [rootMargin])

  return (
    <div ref={ref} style={visible ? undefined : { minHeight }}>
      {visible ? children : fallback}
    </div>
  )
}
